<template>
	<div class="parameter-item">
		<div class="left-side-actions" :class="{ 'opacity-1': mode === 'edit' }">
			<button v-show="mode === 'view'" class="action-btn-sm edit-btn" @click="edit()">
				<i class="fas fa-pen-to-square"></i>
			</button>
			<button v-show="mode === 'view'" class="action-btn-sm remove-btn" @click="remove()">
				<i class="fas fa-trash-can"></i>
			</button>
			<button v-show="mode === 'edit'" class="action-btn-sm save-btn" @click="save()">
				<i class="fas fa-check"></i>
			</button>
			<button v-show="mode === 'edit'" class="action-btn-sm cancel-btn" @click="cancel()">
				<i class="fas fa-times"></i>
			</button>
		</div>
		<div class="details-container">
			<div class="main-details">
				<div class="qd-col-form-group">
					<span class="qd-col-form-title">نام:</span>
					<input class="qd-col-form-data qd-input" :class="{ 'invisible-input': mode === 'view' }" :disabled="mode === 'view'" key="text" v-model="localData.name" style="width:80px;" />
				</div>
				<div class="qd-col-form-group">
					<span class="qd-col-form-title">نوع:</span>
					<select v-model="localData.type" class="qd-col-form-data qd-dropdown" :class="{ 'invisible-input': mode === 'view' }" :disabled="mode === 'view'" style="width:118px;">
						<option v-for="t in types" :key="t.value" :value="t.value">
							{{ t.title }}
						</option>
					</select>
				</div>
				<div class="qd-info mx-1" title="در صورت اجباری بودن پارامتر تیک سمت چپ را فعال کنید."><i class="fal fa-circle-info"></i></div>
				<input class="qd-checkbox" type="checkbox" v-model="localData.isRequired" :disabled="mode === 'view'" />
			</div>
			<div class="extra-details w-100" v-if="localData.type == 'smartDate'">
				<div class="smart-date-fields" v-if="localData.type == 'smartDate'">
					<div class="d-flex align-items-center justify-content-between">
						<div>
							<select class="qd-dropdown" v-model="localData.smartDate.startOrEnd" :class="{ 'invisible-input': mode === 'view' }" :disabled="mode === 'view'">
								<option value="start">شروع</option>
								<option value="end">پایان</option>
							</select>
						</div>
						<div>
							<input class="qd-input" key="text" v-model="localData.smartDate.count" style="width: 60px;" placeholder="تعداد" :class="{ 'invisible-input': mode === 'view' }" :disabled="mode === 'view'" />
						</div>
						<div>
							<select class="qd-dropdown" v-model="localData.smartDate.type" :class="{ 'invisible-input': mode === 'view' }" :disabled="mode === 'view'">
								<option value="day">روز</option>
								<option value="week">هفته</option>
								<option value="month">ماه</option>
								<option value="year">سال</option>
							</select>
						</div>
						<div>
							<select class="qd-dropdown" v-model="localData.smartDate.direction" :class="{ 'invisible-input': mode === 'view' }" :disabled="mode === 'view'">
								<option value="past">گذشته</option>
								<option value="future">آینده</option>
							</select>
						</div>
					</div>
				</div>
				<div v-else-if="localData.type === 'enum'">
					<select v-model="localData.enum">
						<option v-for="item in enumItems" :value="item.type" :key="item.title">
							{{ item.title }}
						</option>
					</select>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex'

	export default {
		name: 'ReportParameterItem',
		props: {
			modelValue: {
				type: Object,
			},
		},
		emits: ['remove'],
		data() {
			return {
				localData: null,
				mode: 'view',
				isNew: false,
				variableVisible: false,
				selectedVariableItem: null,
			}
		},
		created() {
			this.localData = { ...this.modelValue }
			if (this.localData.isNew) {
				this.mode = 'edit'
				this.isNew = true
				delete this.localData.isNew
			}
		},
		computed: {
			...mapGetters({
				entitiesStructure: 'queryDesigner/entitiesStructure'
			}),
			types() {
				return [
					{ title: 'متنی', value: 'string' },
					{ title: 'عددی', value: 'number' },
					{ title: 'تاریخ', value: 'date' },
					{ title: 'تاریخ جاری', value: 'currentDate' },
					{ title: 'تاریخ هوشمند', value: 'smartDate' },
					{ title: 'guid', value: 'guid' },
					{ title: 'enum', value: 'enum' },
					{ title: 'شرکت جاری', value: 'currentCompany' },
					{ title: 'دوره جاری', value: 'currentFiscalPeriod' },

				]
			},
			enumItems() {
				let enumItems = []
				for (let entity of this.entitiesStructure) {
					entity.columns.forEach(item => {
						if (item.type.startsWith('Enum_')) {
							enumItems.push(item)
						}
					})
				}
				return enumItems
			}
		},
		methods: {
			...mapActions({
				removeParameter: 'queryDesigner/removeParameter',
				saveOrUpdateParameter: 'queryDesigner/saveOrUpdateParameter',
			}),
			edit() {
				this.mode = 'edit'
			},
			save() {
				this.saveOrUpdateParameter(this.localData)
				this.mode = 'view'
				this.isNew = false
			},
			cancel() {
				this.mode = 'view'
				if (this.isNew) this.$emit('remove', this.localData)
			},
			remove() {
				if (this.isNew) this.$emit('remove', this.localData)
				else {
					if (confirm('آیا از حذف این پارامتر مطمئن هستید؟')) {
						this.removeParameter(this.localData)
					}
				}
			},
		},
	}
</script>

<style lang="less"></style>